import React, { useState, useEffect } from "react";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import HouseChargeTable from "./HouseChargeTable";

import ReusableModal from "../ManageSettings/ReusableModal";
import { useToastHandler } from '../../../common/ToastHandler'

function HouseCharges() {
  const [gas, setGas] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const [paymentType, setPaymentType] = useState("Cash");
  const [selectedBank, setSelectedBank] = useState("");
  const [chequeNumber, setChequeNumber] = useState("");
  const { Patch, Delete, _Get } = useApi();
  const [loading, setLoading] = useState(false);
  const [banks, setBanks] = useState([]);
   const{handleToast} = useToastHandler()
  useEffect(() => {
    const fetchGasData = () => {
      setLoading(true);

      _Get("houseChargeData")
        .then((response) => {
          setGas(response);
        })
        .catch((error) => {
          console.error("Error fetching gas data:", error);
          handleToast({
            type:"ERROR",
            message: `Error fetching gas data: ${error}`
          })
        })
        .finally(() => {
          setLoading(false);
        });
    };

    fetchGasData();
    fetchBank();
  }, []);

  const handleDeleteHouseCharge = () => {
    if (!selectedCharge) return;

    Delete("houseChargeData", selectedCharge.id)
      .then(() => {
        setGas((prevGas) =>
          prevGas.filter((item) => item.id !== selectedCharge.id)
        );
        closeModal();

        handleToast({
          type:"SUCCESS",
          message:"House charge deleted successfully!"
        })
      })
      .catch((error) => {

        handleToast({
          type:"ERROR",
          message:"An error occurred while deleting the charge."
        })
        console.error("Error deleting house charge:", error);
      })
      .finally(() => {
        closeModal();
      });
  };

  const handleEnableDisable = (id, currentStatus) => {
    const selectedCharge = gas.find((item) => item.id === id);
    if (selectedCharge) {
      openModal(selectedCharge);
    }
  };

  const fetchBank = () => {
    _Get("bank")
      .then((bankResponse) => {
        setBanks(bankResponse);
      })
      .catch((error) => {
        console.error("Error fetching banks data:", error);
        handleToast({
          type:"ERROR",
          message:`Error fetching bank data: ${error}`
        })
      });
  };

  const handleHouseChanrgeSubmit = (e) => {
    e.preventDefault();
    if (!selectedCharge) return;

    Patch("houseChargeData", selectedCharge.id, {
      ...selectedCharge,
      pay_method: paymentType,
      bank: selectedBank,
      cheque_no: chequeNumber,
      notes: selectedCharge.notes,
      is_paid: true,
    })
      .then((response) => {
        setGas((prevGas) =>
          prevGas.map((item) =>
            item.id === selectedCharge.id
              ? {
                  ...item,
                  pay_method: paymentType,
                  bank: selectedBank,
                  cheque_no: chequeNumber,
                  notes: selectedCharge.notes,
                  is_paid: true,
                }
              : item
          )
        );

        if (response.success) {
          closeModal();
        }
      })
      .catch((error) => {
        console.error("Error updating charge:", error);
        handleToast({
          type:"ERROR",
           message:`Error updating charge:${error}`
        })
      })
      .finally(() => {
        closeModal();
      });
  };

  const openModal = (charge) => {
    setSelectedCharge(charge);
    setPaymentType(charge.pay_method || "Cash");
    setSelectedBank(charge.bank || "");
    setChequeNumber(charge.cheque_no || "");
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedCharge(null);
    setIsModalOpen(false);
  };

  const columns = [
    { header: "Date", field: "bill_date" },
    { header: "Gas Company", field: "company_title" },
    { header: "Amount", field: "amount" },
  ];

  return (
    <>
      <div className="due-days">
        <HouseChargeTable
          data={gas}
          columns={columns}
          showAction={true}
          showFooter={true}
          handleRowClick={openModal}
          handleEnableDisable={handleEnableDisable}
          loading={loading}
        />
      </div>

      <ReusableModal
        show={isModalOpen}
        handleClose={closeModal}
        title={
          selectedCharge?.is_paid ? "Transaction Details" : "Mark As Received"
        }
      >
        {selectedCharge?.is_paid ? (
          <div>
            <table
              className="data-table custom-table"
              style={{
                borderRadius: "20px 20px 20px 20px",
                border: "1px solid #EBEAF2",
                borderCollapse: "separate",
                borderSpacing: 0,
                overflow: "hidden",
              }}
            >
              <thead className="table-header">
                <tr>
                  <th className="p-2 border-b">Date</th>
                  <th className="p-2 border-b">Type</th>
                  <th className="p-2 border-b">Amount</th>
                  <th className="p-2 border-b">Action</th>
                </tr>
              </thead>
              <tbody className="table-body">
                <tr>
                  <td className="p-2">{selectedCharge.bill_date}</td>
                  <td className="p-2">{selectedCharge.pay_method}</td>
                  <td className="p-2">${selectedCharge.amount}</td>
                  <td>
                    <svg
                      onClick={handleDeleteHouseCharge}
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.00016 12.6667C4.00016 13.4 4.60016 14 5.3335 14H10.6668C11.4002 14 12.0002 13.4 12.0002 12.6667V6C12.0002 5.26667 11.4002 4.66667 10.6668 4.66667H5.3335C4.60016 4.66667 4.00016 5.26667 4.00016 6V12.6667ZM12.0002 2.66667H10.3335L9.86016 2.19333C9.74016 2.07333 9.56683 2 9.3935 2H6.60683C6.4335 2 6.26016 2.07333 6.14016 2.19333L5.66683 2.66667H4.00016C3.6335 2.66667 3.3335 2.96667 3.3335 3.33333C3.3335 3.7 3.6335 4 4.00016 4H12.0002C12.3668 4 12.6668 3.7 12.6668 3.33333C12.6668 2.96667 12.3668 2.66667 12.0002 2.66667Z"
                        fill="#000000"
                      />
                    </svg>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <form onSubmit={handleHouseChanrgeSubmit}>

            <div style={{ display: "flex", gap: "30px", marginBottom: "20px" }}>
              <input
                type="date"
                className="form-control-borderless"
                name="date"
                value={selectedCharge?.bill_date || ""}
                onChange={(e) =>
                  setSelectedCharge({
                    ...selectedCharge,
                    bill_date: e.target.value,
                  })
                }
                required
              />

              <input
                type="text"
                className="form-control-borderless"
                name="amount"
                value={selectedCharge?.amount || ""}
                onChange={(e) =>
                  setSelectedCharge({
                    ...selectedCharge,
                    amount: e.target.value,
                  })
                }
                placeholder="Amount"
                required
              />

              <input
                type="text"
                className="form-control-borderless"
                name="companyTitle"
                value={selectedCharge?.company_title || ""}
                onChange={(e) =>
                  setSelectedCharge({
                    ...selectedCharge,
                    company_title: e.target.value,
                  })
                }
                placeholder="Company"
              />
            </div>
            <div
              style={{
                display: "flex",

                background: "#FFFFFF",
                padding: "4px",
                borderRadius: "40px",
                border: "1px solid #ACB4AA",
                marginBottom: "20px",
                maxWidth: "410px",
              }}
            >
              {["Cash", "Cheque", "Bank Card/ACH/EFT"].map((type) => (
                <button
                  key={type}
                  type="button"
                  style={{
                    padding: "5px 10px",
                    borderRadius: "40px",
                    border: "none",
                    backgroundColor:
                      paymentType.toLowerCase() === type.toLowerCase()
                        ? "#4A5546"
                        : "transparent",
                    color:
                      paymentType.toLowerCase() === type.toLowerCase()
                        ? "#F4FFEE"
                        : "#4A5546",
                    cursor: "pointer",
                    fontSize: "18px",
                    flex: "0 0 auto",
                    margin: "0 4px",
                    minWidth: `${type.length * 10 + 30}px`,
                    textAlign: "center",
                  }}
                  onClick={() => {
                    setPaymentType(type.toLowerCase());
                    setSelectedBank("");
                    setChequeNumber("");
                  }}
                >
                  {type}
                </button>
              ))}
            </div>
            <div style={{ marginBottom: "20px" }}>
              <input
                type="text"
                className="form-control-borderless"
                style={{ maxWidth: "270px" }}
                name="note"
                value={selectedCharge?.notes || ""}
                onChange={(e) =>
                  setSelectedCharge({
                    ...selectedCharge,
                    notes: e.target.value,
                  })
                }
                placeholder="Notes"
              />
            </div>

            {["cheque", "bank", "bank card/ach/eft"].includes(paymentType) && (
              <div
                style={{ display: "flex", gap: "16px", marginBottom: "20px" }}
              >
                <select
                  required
                  className="form-control-borderless"
                  style={{ maxWidth: "270px" }}
                  name="bank"
                  value={selectedCharge?.bank || ""}
                  onChange={(e) =>
                    setSelectedCharge({
                      ...selectedCharge,
                      bank: e.target.value,
                    })
                  }
                >
                  <option value="">Select Bank</option>
                  {banks.map((bank) => (
                    <option key={bank.id} value={bank.name}>
                      {bank.name}
                    </option>
                  ))}
                </select>

                {paymentType === "cheque" && (
                  <input
                    type="text"
                    className="form-control-borderless"
                    name="cheque_number"
                    value={chequeNumber}
                    onChange={(e) => setChequeNumber(e.target.value)}
                    placeholder="Cheque Number"
                    required
                    style={{ maxWidth: "270px" }}
                  />
                )}
              </div>
            )}

            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                type="submit"
                style={{
                  padding: "12px 40px",
                  borderRadius: "40px",
                  backgroundColor: "#4A5546",
                  color: "#F4FFEE",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "500",
                  transition: "all 0.2s",
                }}
              >
                Save
              </button>
            </div>
          </form>
        )}
      </ReusableModal>
    </>
  );
}

export default HouseCharges;